import { useLocation } from 'react-router'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'



interface BackButtonProps {
  className?: string;
  onClick?: () => void;
}

export default function BackButton (props: BackButtonProps) {
  const { className, onClick } = props
  const navigate = useNavigate()
  const location = useLocation()

  const handleClick = () => {
    if (window.history.length <= 2 || location.key === 'default') {
      navigate('/')
    }
    else {
      navigate(-1)
    }
  }

  return (
    <Button
      className={cn(styles.root, className)}
      theme="grey"
      onClick={onClick ?? handleClick}
    >
      <ReactSVG src="/icons/arrow.svg" wrapper="span" width={20} height={20} />
    </Button>
  )
}
